import React from "react";
import { Paper, PaperProps, Typography } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { Statement } from "../../../../../../../services/royalties/types/statement";
import DineroFactory, { Dinero } from "dinero.js";

interface EarningsStatementProps extends PaperProps {
  userId: string;
  statement: Statement[];
  loading: boolean;
}

interface StatementGrid extends Statement {
  id: string;
  balance?: Dinero;
}

export const EarningsStatement: React.FC<EarningsStatementProps> = ({
  statement,
  loading,
  userId,
  ...props
}) => {
  const data: StatementGrid[] = statement
    .map((item) => ({ ...item, id: `${item.userId}-${item.eligibleDate}` }))
    .concat([
      {
        id: "BALANCE",
        userId,
        eligibleDate: "Total",
        earnings: statement.reduce(
          (memo, item) => memo.add(item.earnings),
          DineroFactory({ amount: 0, precision: 2, currency: "USD" })
        ),
        payouts: statement.reduce(
          (memo, item) => memo.add(item.payouts),
          DineroFactory({ amount: 0, precision: 2, currency: "USD" })
        ),
        balance: statement.reduce(
          (memo, item) => memo.add(item.earnings).subtract(item.payouts),
          DineroFactory({ amount: 0, precision: 2, currency: "USD" })
        ),
      } as StatementGrid,
    ]);

  return (
    <Paper
      {...props}
      style={{ padding: "20px", overflow: "hidden", ...props.style }}
    >
      <Typography variant="h6">Statement</Typography>

      <div style={{ display: "flex", height: "450px", marginTop: "20px" }}>
        <DataGrid
          loading={loading}
          rows={data}
          columns={[
            {
              field: "eligibleDate",
              headerName: "Eligible Period",
              width: 250,
            },
            {
              field: "earnings",
              headerName: "Earnings",
              width: 400,
              type: "number",
              valueFormatter: (params) => (params.value as Dinero).toFormat(),
            },
            {
              field: "payouts",
              headerName: "Payouts",
              width: 400,
              type: "number",
              valueFormatter: (params) => (params.value as Dinero).toFormat(),
            },
            {
              field: "balance",
              headerName: "Balance",
              width: 400,
              type: "number",
              valueFormatter: (params) =>
                (params.value as Dinero)?.toFormat() || "",
            },
          ]}
          pageSize={100}
        />
      </div>
    </Paper>
  );
};
